import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=4475cb2b&"
import script from "./Voucher.js?vue&type=script&lang=js&"
export * from "./Voucher.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports